import * as loadingState from '../constants/loadingState';

export const RESET_PASSWORD_INITIALIZE = 'RESET_PASSWORD_INITIALIZE';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
export const RESET_PASSWORD_COMPLETE = 'RESET_PASSWORD_COMPLETE';

export const CLOSE_EDIT_PANEL = 'CLOSE_EDIT_PANEL';

export const resetPasswordInitialize = () => ({
  type: RESET_PASSWORD_INITIALIZE,
});

export const resetPassword = ({
  currentPassword,
  newPassword,
  confirmNewPassword,
}) => ({
  type: RESET_PASSWORD,
  payload: {
    currentPassword,
    newPassword,
    confirmNewPassword,
  },
});

export const resetPasswordSuccess = () => ({ type: RESET_PASSWORD_SUCCESS });

export const resetPasswordFailure = errorCode => ({
  type: RESET_PASSWORD_FAILURE,
  payload: {
    errorCode,
  },
});

export const resetPasswordComplete = () => ({ type: RESET_PASSWORD_COMPLETE });

export const closeEditPanel = () => ({ type: CLOSE_EDIT_PANEL });

const INIT_STATE = {
  resetPasswordOpen: false,
  resetPasswordStatus: loadingState.EMPTY,
  errorCode: '',
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_PASSWORD_INITIALIZE:
      return {
        ...state,
        resetPasswordStatus: loadingState.EMPTY,
        resetPasswordOpen: true,
        errorCode: '',
      };
    case RESET_PASSWORD:
      return {
        ...state,
        resetPasswordStatus: loadingState.LOADING,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordStatus: loadingState.READY,
        resetPasswordOpen: false,
        errorCode: '',
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordStatus: loadingState.ERROR,
        errorCode: action.payload.errorCode,
      };
    case RESET_PASSWORD_COMPLETE:
      return {
        ...state,
        resetPasswordStatus: loadingState.EMPTY,
        resetPasswordOpen: false,
        errorCode: '',
      };
    case CLOSE_EDIT_PANEL:
      return {
        ...state,
        resetPasswordOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;

export const getErrorCode = state => state.resetPassword.errorCode;
export const getOpenStatus = state => state.resetPassword.resetPasswordOpen;



// WEBPACK FOOTER //
// ./app/redux/resetPassword.js